
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile",
      oss: "oss"
    }),
    formattedTitle01() {
      const title = String(this.$t("retro63RT.title01"));
      // 将单独的x字母用span包裹，使用默认字体
      return title
        .replace(/ x /g, ' <span class="x-letter">x</span> ')
        .replace(/>x /g, '><span class="x-letter">x</span> ');
    }
  },
  methods: {
    onDownload(url: string) {
      download(url);
    },
    onOpen(url: string) {
      window.open(url, "_blank");
    },
    onAdmin() {
      const element = document.getElementById("rt-admin");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  },
  mounted() {
    if (!this.isCN) {
      // this.$router.back();
      // this.onOpen("https://bit.ly/3PHs2jO");
    }
  }
});
